import { DataAttributeDefinitions } from 'scrivito'

import { pisaDocumentDocumentRelationDataClass } from './Pisa/pisaDocumentDocumentRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const DocumentDocumentRelation =
  pisaDocumentDocumentRelationDataClass(attributes)
